import { useIntl } from 'react-intl';
import { PROVIDER_TITLES } from '../constants';
import { localizedProviderTitleId } from '../helpers';
import { useCallback } from 'react';
const defaultMessage = (title) => title === 'Other' ? '--' : title;
export const useProviderTitleLocalization = () => {
    const { formatMessage } = useIntl();
    return useCallback((title, showOther = false) => {
        return title && (showOther || title !== 'Other')
            ? formatMessage({
                id: localizedProviderTitleId(title),
                defaultMessage: defaultMessage(title),
            })
            : '';
    }, [formatMessage]);
};
export const useLocalizedProviderTitles = () => {
    const providerTitleLocalization = useProviderTitleLocalization();
    return PROVIDER_TITLES.map((key) => ({
        key,
        label: providerTitleLocalization(key, true),
    }));
};
